import type { FC } from 'react';

import negativeSentiment from 'src/assets/dashboard/negative-sentiment.svg';
import neutralSentiment from 'src/assets/dashboard/neutral-sentiment.svg';
import positiveSentiment from 'src/assets/dashboard/positive-sentiment.svg';
import type { SentimentCode } from 'src/types/dashboard';

interface SentimentIconProps {
  sentiment: SentimentCode;
}

const SentimentIcon: FC<SentimentIconProps> = ({ sentiment }) =>
  sentiment === -1 ? (
    <img src={negativeSentiment} alt={'negative-sentiment-icon'} />
  ) : sentiment === 0 ? (
    <img src={neutralSentiment} alt={'neutral-sentiment-icon'} />
  ) : (
    <img src={positiveSentiment} alt={'positive-sentiment-icon'} />
  );

export default SentimentIcon;
